module.exports = __webpack_public_path__ + "img/lead-service3.d275ba7d.jpg";